"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export function useColorMode() {
  const $ = _c(6);
  const [isDark, setIsDark] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== isDark) {
    t0 = () => {
      document.documentElement.classList.toggle("dark", isDark);
      localStorage.setItem("nt-theme", isDark ? "dark" : "light");
    };
    t1 = [isDark];
    $[0] = isDark;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsDark(_temp2);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggle = t2;
  let t3;
  if ($[4] !== isDark) {
    t3 = {
      isDark,
      toggle
    };
    $[4] = isDark;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp2(prev) {
  return !prev;
}
function _temp() {
  if (typeof window === "undefined") {
    return false;
  }
  return localStorage.getItem("nt-theme") === "dark";
}